<template>
	<div style="overflow-x: hidden !important">
		<div style="display: flex; flex-direction: column">
			<!-- SIDEBAR -->
			<div class="menu" :style="{ width: sidebar ? '' : '75px' }">
				<button-collapse-sidebar :open="sidebar" @change="sidebar = !sidebar" />
				<folders-sidebar :open="sidebar" />
			</div>

			<div class="main" :style="{ width: widthscreen, marginLeft: !sidebar ? '75px' : '150px' }">
				<div style="padding: 10px; margin-top: 15px">
					<div>
						<div
							style="
								width: 100%;
								height: 90vh;
								display: inline-flex;
								flex-direction: row;
								border-radius: 20px;
							"
						>
							<div style="width: 20%; background-color: #fff">
								<div style="display: flex; flex-direction: column">
									<!--								SEARCH + ACTIONS	-->
									<div class="menu-header md-elevation-3" :key="`list_header`">
										<div
											style="
												padding-left: 10px;
												display: flex;
												flex-direction: column;
												align-content: center;
												align-items: center;
												align-self: center;
												height: 100%;
											"
										>
											<div
												style="
													display: flex;
													flex-direction: row;
													align-content: center;
													align-items: center;
													align-self: center;
													height: 100%;
												"
											>
												<el-input :placeholder="$t('search')" v-model="searchEl"></el-input>
												<el-tooltip content="Nuovo blocco" placement="bottom" :open-delay="500">
													<md-button class="md-icon-button" @click="addEl()">
														<md-icon>add</md-icon>
													</md-button>
												</el-tooltip>
												<el-tooltip
													:content="$t('show-hide-enabled')"
													placement="bottom"
													:open-delay="500"
												>
													<md-button class="md-icon-button" @click="toggleDeleted()">
														<md-icon v-if="!showDeleted">visibility</md-icon>
														<md-icon v-else>visibility_off</md-icon>
													</md-button>
												</el-tooltip>
											</div>
										</div>
									</div>
									<!--									BLOCKS LIST -->
									<div style="overflow-y: scroll; height: 83vh">
										<template v-if="!showDeleted">
											<div
												class="menu-card md-elevation-3"
												v-for="(element, index) in searched"
												:key="index + element.id"
												@click="loadSavedElement(element)"
											>
												<div
													style="
														padding-left: 10px;
														display: flex;
														flex-direction: column;
														align-content: center;
														align-items: center;
														align-self: center;
														height: 100%;
													"
												>
													<div
														style="
															display: flex;
															flex-direction: row;
															align-content: center;
															align-items: center;
															align-self: center;
															height: 100%;
															word-break: break-all;
														"
													>
														<div style="padding: 10px">{{ element.name }}</div>
													</div>
												</div>
											</div>
										</template>
										<template v-else>
											<div
												class="menu-card md-elevation-3"
												v-for="(element, index) in searchedDeleted"
												:key="index + element.id"
												@click="loadSavedElement(element)"
											>
												<div
													style="
														padding-left: 10px;
														display: flex;
														flex-direction: column;
														align-content: center;
														align-items: center;
														align-self: center;
														height: 100%;
													"
												>
													<div
														style="
															display: flex;
															flex-direction: row;
															align-content: center;
															align-items: center;
															align-self: center;
															height: 100%;
															word-break: break-all;
														"
													>
														<div>
															<md-icon v-if="element.deleted">delete_outline</md-icon>
														</div>
														<div style="padding: 10px">{{ element.name }}</div>
													</div>
												</div>
											</div>
										</template>
									</div>
								</div>
							</div>

							<!--							MAIN -->
							<div style="width: 80%; background-color: #ffffff">
								<div
									v-if="editedItem !== undefined"
									style="width: 100%; height: 100%; display: flex; flex-direction: column"
								>
									<div
										style="
											height: auto;
											width: 100%;
											display: inline-flex;
											border-left: 1px solid gray;
										"
										class="md-elevation-4"
									>
										<div style="margin-right: auto; margin-left: 20px">
											<div v-if="editedItem && editTitle == false" style="display: inline-flex">
												<h3
													style="
														margin-top: 10px;
														margin-bottom: 10px;
														max-width: 600px;
														overflow: hidden;
														word-break: break-all;
														max-height: 40px;
													"
												>
													{{ editedItem.name }}
												</h3>
												<el-tooltip v-if='editedItem.wiki' style='border:none; width: 25px' class="item" effect="dark" :content="editedItem.wiki" placement="top">
													<md-icon>help_outline</md-icon>
												</el-tooltip>
												<md-button
													style="margin-top: 10px !important; margin-bottom: 10px !important"
													class="md-icon-button"
													@click="editTitle = true"
												>
													<md-icon>edit</md-icon>
												</md-button>
											</div>
											<div v-if="editedItem && editTitle == true" style="display: inline-flex">
												<el-input
													style="margin-top: 10px; margin-bottom: 10px"
													v-model="editedItem.name"
												></el-input>

												<md-button
													style="margin-top: 10px !important; margin-bottom: 10px !important"
													class="md-icon-button"
													@click="editTitle = false"
												>
													<md-icon>save</md-icon>
												</md-button>
											</div>



											<el-button @click='editWiki=true' type="primary">{{ $t( 'set-wiki' ) }}</el-button>
											<el-dialog
												:title="$t('set-wiki')"
												:visible.sync="editWiki"
												width="60%"
												:before-close="
				() => {
					this.editWiki = false
				}
			"
											>
												<el-input type="textarea" :rows="2" :placeholder="$t('set-wiki-placeholder')" v-model="editedItem.wiki">
												</el-input>
											</el-dialog>
										</div>
										<div style="margin-right: 20px; margin-left: auto; width: max-content">
											<div style="margin-top: 10px; margin-bottom: 10px">
												<md-button @click="dialogVisible = true">{{ $t("preview") }}</md-button>
												<md-button @click="updateCh()">{{ $t("save") }}</md-button>
												<md-button @click="delEl()" v-if="!editedItem.deleted">{{ $t("disable") }}</md-button>
												<md-button v-if="editedItem.deleted" @click="recoverEl()">
													{{ $t("enable") }}
												</md-button>
											</div>
										</div>
									</div>

									<!--DIALOG CSS-->
									<el-dialog v-if="toedit" :title="$t('edit')" :visible.sync="showEdit" width="60%">
										<css-modal v-if="showEdit"></css-modal>
									</el-dialog>

									<!--   DIALOG SAVE BLOCK -->
									<el-dialog
										:title="$t('insert')"
										:visible.sync="showInsert"
										width="30%"
										@close="hideModalInsert()"
									>
										<el-input v-model="toinsert.name"></el-input>
										<el-button
											type="primary"
											@click="
												addElement()
												hideModalInsert()
											"
										>
											{{ $t("save") }}
										</el-button>
										<el-button type="primary" @click="hideModalInsert()"
										>{{ $t("close") }}
										</el-button>
									</el-dialog>

									<!--    DIALOG PREVIEW -->
									<el-dialog
										:title="$t('preview')"
										:visible.sync="dialogVisible"
										width="80%"
										:key="editedItem.id + 'dialog'"
									>
										<!--                        <raw-displayer :value="[{items:[editedItem]}]"></raw-displayer>-->
										<Renderer
											v-if="dialogVisible"
											:toggleBorders="toggleBorders"
											:dati="[{ items: [editedItem] }]"
										></Renderer>

										<span slot="footer">
											<el-switch
												v-model="toggleBorders"
												:active-text="$t('with-borders')"
												:inactive-text="$t('without-borders')"
											/>
											<el-button type="primary" @click="dialogVisible = false">{{
													$t("close")
												}}</el-button>
										</span>
									</el-dialog>

									<!--    BLOCK DETAILS -->
									<div style="display: flex; flex-direction: row; height: 100%" :key="editedItem.id">
										<div style="width: 30%; height: 90%; overflow-y: scroll">
											<draggable
												v-model="list"
												class="dragArea list-group"
												:options="ListOptions"
												:clone="clone"
												:empty-insert-threshhold="500"
												:scroll-sensitivity="200"
												:force-fallback="true"
												style="
													overflow-y: scroll;
													min-height: 100px !important;
													min-width: 60px;
													width: 95%;
													padding: 10px;
													margin: 10px;
												"
											>
												<el-card
													@dblclick.native="dblClick(element)"
													class="box-card"
													style="
														width: 45%;
														display: inline-block;
														margin: 5px;
														border-radius: 15px;
													"
													v-for="element in list"
													:key="element.id"
												>
													{{ element.name }}
												</el-card>
											</draggable>
										</div>
										<div style="width: 70%; overflow-y: scroll; height: 90%">
											<div
												style="
													background-color: whitesmoke;
													width: auto;
													height: inherit;
													margin: 20px;
													border-radius: 20px;
												"
												v-if="editedItem"
											>
												<el-card class="box-card" :key="editedItem.id">
													<div style="width: 100%; height: auto; min-height: 60px">
														<md-icon class="handle" style="float: left">open_with</md-icon>
														<div
															class="handle"
															style="float: left; max-width: 600px; overflow: hidden"
														>
															&nbsp;
															{{ editedItem.name }}
														</div>
														<el-button class="_btn" @click="editEl(editedItem)" circle>
															<md-icon>edit</md-icon>
														</el-button>
													</div>
													<!--
													DOC

													reflect component renderezza in preview l'effettivo elemento interessato dal drag (casella di testo, editor, immagine ecc)
													e se necessario gli elementi figli (per esempio sulle righe)

													-->
													<reflect-component
														:key="editedItem.id + 'subelements'"
														:is-editable="true"
														:element="editedItem"
													></reflect-component>
												</el-card>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"
import ReflectComponent from "@/modules/builder/Reflect/reflect-component"
import RawDisplayer from "@/modules/builder/components/raw-displayer"
import draggable from "vuedraggable"
import { clone, cloneAt, uuid } from "@/modules/builder/utils/utils"
import axios from "axios"
import { i18n } from "@/plugins/i18n"
import Renderer from "@/modules/builder/components/Renderer"
import { goto } from "@/utils/utils"
import HowToUse from "@/modules/builder/components/how-to-use"
import ButtonCollapseSidebar from "@/modules/_common/button/button-collapse-sidebar.vue"
import FoldersSidebar from "@/modules/documents/components/sidebar-components/folders-sidebar.vue"
import AppBreadcrumb from "@/modules/_common/app-breadcrumb.vue"
import CssModal from "@/modules/builder/components/css-modal"

export default {
	name: "flowchart-saved-components",
	components: {
		RawDisplayer,
		ReflectComponent,
		draggable,
		clone,
		cloneAt,
		Renderer,
		AppBreadcrumb,
		"button-collapse-sidebar": ButtonCollapseSidebar,
		"folders-sidebar": FoldersSidebar,
		HowToUse,
		CssModal
	},
	data() {
		return {
			editedItem: undefined,
			searchEl: "",
			editTitle: false,
			dialogVisible: false,
			toggleBorders: false,
			showDeleted: false,
			sidebar: true || window.innerWidth < 900,
			widthscreen: window.innerWidth - 150,
			heightscreen: window.innerHeight,
			mobile: window.innerWidth < 900,
			useless: 0,
			editWiki:false
		}
	},
	computed: {
		searched: function() {
			return this.listSaved.filter(str =>
				str.name.replace(/\s+/g, "").toLowerCase().includes(this.searchEl.replace(/\s+/g, "").toLowerCase())
			)
		},
		searchedDeleted: function() {
			return this.listDeleted.filter(str =>
				str.name.replace(/\s+/g, "").toLowerCase().includes(this.searchEl.replace(/\s+/g, "").toLowerCase())
			)
		},
		...mapGetters({
			listSaved: "builder/listSaved",
			listDeleted: "builder/listDeleted",
			list: "builder/list",
			toedit: "builder/toedit",
			toinsert: "builder/toinsert",
			showEdit_state: "builder/showEdit",
			selectOptions: "builder/selectOptions",
			showInsert: "builder/showInsert"
		}),

		showEdit: {
			get() {
				return this.showEdit_state
			},
			set(el) {
				if (el) {
					this.show_edit()
				} else {
					this.hide_edit()
				}
			}
		},
		ListOptions() {
			return {
				group: {
					name: "items",
					pull: "clone",
					put: false
				},
				sort: false,
				ghostClass: "ghostCustom",
				dragClass: "ghostCustom",
				chosenClass: "dragCustomClass",
				animation: 200
			}
		}
	},

	methods: {
		goto,
		uuid,
		updateCh() {
			if (this.editedItem.ref_id) {
				axios
					.post(
						process.env.VUE_APP_API_URL + "/api/blocks/updateBlock",
						{
							id: this.editedItem.ref_id,
							content: this.editedItem
						},
						{
							headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
						}
					)
					.then(res => {
						if (res.data.status == "ok") {
							this.$notification("success", this.$t("saved-element-generic"), "")
							return true
						}
					})
					.catch(err => {
						this.$notification("error", this.$t("save-error"), "",0)
					})
			} else {
				axios
					.post(
						process.env.VUE_APP_API_URL + "/api/blocks/saveBlock",
						{ element: this.editedItem },
						{
							headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
						}
					)
					.then(res => {
						if (res.data.status == "ok") {
							this.editedItem.ref_id = res.data.id
							this.$notification("success", i18n.t("saved-element-generic"), "")
							return true
						}
					})
					.catch(err => this.$notification("error", i18n.t("save-error"), "", 0))
			}
		},
		addEl() {
			var tmp2 = JSON.parse(JSON.stringify(this.list.find(x => x.name === "contenitore")))
			tmp2.name = "Nuovo blocco"
			tmp2.id = this.uuid()
			this.pushListSaved(tmp2)
		},
		cloneAt,
		clone,
		...mapActions({
			loadList: "builder/loadList",
			editEdit: "builder/editEdit",
			showModalEdit: "builder/showModalEdit",
			deleteCustomEL: "builder/deleteCustomEL",
			hideModalInsert: "builder/hideModalInsert",
			addElement: "builder/addElement",
			editInsert: "builder/editInsert",
			showModalInsert: "builder/showModalInsert",
			setCut: "builder/setCut"
		}),
		...mapMutations({
			pushListSaved: "builder/PUSH_LIST_SAVED"
		}),
		loadSavedElement(element) {
			this.editedItem = undefined
			if (element.hasChildren === 0) {
				var tmp = JSON.parse(JSON.stringify(this.list.find(x => x.name === "contenitore")))
				tmp.id = Math.random().toString(16).slice(2)
				tmp.items = []
				tmp.items.push([element])
				tmp.ref_id = element.ref_id
				tmp.deleted = element.deleted
				element.ref_id = undefined
				tmp.name = element.name
				tmp.wiki =  element.wiki
				this.editedItem = tmp
			} else {
				this.editedItem = element
			}
		},
		saveEl(el) {
			/**
			 * DOC
			 * inserisce un nuovo elemento custom basato su quello attuale,
			 * la funzione clone e l'id randomico garantiscono la separazione del clone dal padre
			 * per ulteriori dettagli, vedere lo store
			 *
			 * poi apre il modale per il nome
			 *
			 * */
			var toinsertel = clone(el)
			toinsertel.name += "(" + this.$t("saved") + ")"
			toinsertel.id = Math.random().toString(16).slice(2)
			this.editInsert(toinsertel)
			this.showModalInsert()
		},
		editEl(el) {
			/**
			 * DOC
			 * trigger l'edit css dell'elemento
			 * */
			this.editEdit(el)
			this.showModalEdit()
		},
		async delEl() {
			if (this.editedItem.ref_id === undefined) {
				this.$notification("warning", i18n.t("cannot-delete-saved-block"), "")
			} else {
				var res = await this.deleteCustomEL(this.editedItem.ref_id)
				if (res) {
					this.editedItem = undefined
				}
				this.loadList()
			}
		},
		toggleDeleted() {
			this.showDeleted = !this.showDeleted
		},
		recoverEl() {
			axios
				.get(process.env.VUE_APP_API_URL + "/api/blocks/recoverBlock/" + this.editedItem.ref_id, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					this.loadList()
					this.$notification("success", i18n.t("restored-successfully"), "")
				})
				.catch(err => console.error(err))
		},
		async dblClick(e) {
			await this.setCut(this.clone(e))
			this.$notify({
				title: this.$t("copied-success"),

				position: "bottom-right"
			})
			// const temp = this.selected_node
			// temp.value[0].items.push(this.clone(e))
		},
		...mapMutations({
			show_edit: "builder/SHOW_EDIT",
			hide_edit: "builder/HIDE_EDIT"
		})
	},
	mounted() {
		this.loadList()
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/collapse-button";

.main {
	margin-top: -25px;
}

.menu {
	font-family: "Montserrat", sans-serif;
	z-index: 2;
	position: absolute;
	left: 0;
	bottom: 0;
	top: 63px;
	width: 150px;
	background-color: #455a64;
	transition: width 0.5s;
}

.item {
	padding: 17px 10px;
	cursor: pointer;
	color: #cfd8dc;
	width: 100%;

	&:hover {
		border-left: 3px solid #6ff9ff;
	}

	display: flex;

	.md-icon {
		margin-left: 5px;
		margin-right: 5px;
	}

	span {
		margin-top: auto;
		margin-bottom: auto;
	}
}

.item-selected {
	border-left: 3px solid #6ff9ff;
	color: white;
	background-color: rgba(127, 127, 127, 0.1);
}

.selected {
	color: #6ff9ff;
}

.menu-card {
	min-height: 60px;
	margin: 10px;
	width: auto;
	background-color: white;
	border-radius: 20px;

	cursor: pointer;
}

.menu-header {
	height: 60px;
	margin: 0px;
	width: auto;
	background-color: white;

	cursor: pointer;
}

.md-button {
	margin: 0px !important;
}
</style>
